module.exports = __webpack_public_path__ + "static/038.thumb-fa64b33e2d9dfb74507962f6d1c8709c.jpg";